import { Link } from "react-router-dom";
import { getByCategory, sortContent } from "@/lib/content";
import SectionHeader from "@/components/base/SectionHeader";

export default function LatestFilmNews() {
  const list = sortContent(getByCategory("film-news"), "date-desc");
  const [featured, ...rest] = list;
  const sideList = rest.slice(0, 4);

  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-8 md:py-10">
        <SectionHeader
          title="最新影视资讯"
          subtitle="开机杀青、定档上映、票房数据与产业观察"
          moreTo="/category/film-news"
          moreLabel="更多影视资讯"
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {/* 主推 */}
          <Link
            to={`/detail/${featured.id}`}
            className="lg:col-span-2 group rounded-xl overflow-hidden border border-background-200 bg-background-50 cursor-pointer"
          >
            <div className="h-[220px] md:h-[320px] w-full overflow-hidden">
              <img
                src={featured.cover}
                alt={featured.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                <span className="px-2.5 py-1 rounded-full bg-primary-50 text-primary-600 font-medium">
                  影视资讯
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line" /> {featured.date}
                </span>
              </div>
              <h3 className="font-heading text-lg md:text-2xl font-black text-foreground-950 leading-snug mb-3 group-hover:text-primary-600 transition-colors">
                {featured.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                {featured.summary}
              </p>
            </div>
          </Link>

          {/* 列表 */}
          <div className="rounded-xl border border-background-200 bg-background-50 p-5">
            <ul className="space-y-4">
              {sideList.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/detail/${item.id}`}
                    className="flex gap-3 group/item cursor-pointer"
                  >
                    <div className="w-24 h-16 shrink-0 rounded-lg overflow-hidden">
                      <img
                        src={item.cover}
                        alt={item.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="min-w-0">
                      <h4 className="text-sm font-medium text-foreground-800 leading-snug line-clamp-2 group-hover/item:text-primary-600 transition-colors">
                        {item.title}
                      </h4>
                      <span className="text-xs text-foreground-400 mt-1 flex items-center gap-1">
                        <i className="ri-time-line" /> {item.date}
                      </span>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}